const inertDirective = {
  bind(el: HTMLElement, binding: any) {
    el.inert = Boolean(binding.value)
  },
  update(el: HTMLElement, binding: any) {
    el.inert = Boolean(binding.value)
  },
  unbind(el: HTMLElement) {
    el.inert = false
  }
}

export default inertDirective